import axios from "axios";

// import _ from "lodash";


// export const config = {
//   baseURL: process.env.BASE_URL || "http://localhost:8000",
//   baseMiscURL: process.env.BASE_MISC_URL || "http://localhost:8001",
// };

console.log('VUE_APP_BASE_URL:', process.env.VUE_APP_BASE_URL);
console.log('VUE_APP_BASE_MISC_URL:', process.env.VUE_APP_BASE_MISC_URL);
export const config = {
  baseURL: process.env.VUE_APP_BASE_URL,
  baseMiscURL: process.env.VUE_APP_BASE_MISC_URL,

};

export const http = axios.create({
  baseURL: config.baseURL,
});

export const miscServer = axios.create({
  baseURL: config.baseMiscURL, // local WSL
});

// export const ROLES = {
//   ADMIN: 1,
//   DISPATCHER: 2,
//   FINANCE: 3,
//   CORPORATE: 4,
//   OPERATION: 7, 

//   resolveName(roleNumber) {
//     return _.findKey(this, x => x === roleNumber);
//   },
// };

// export const homepages = role => {
//   switch (role) {
//     case 1:
//       return "/dashboard";
//     case 2:
//       return "/manual-trip-booking";
//     case 3:
//       return "/finance";
//     case 4:
//       return "/corporate/dashboard";
//     default:
//       return "/dashboard";
//   }
// };
